"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFILIATION_DS_OVERRIDES = exports.legacyDatasetRepo = void 0;
const torch_data_definitions_1 = require("./lib/torch-data-definitions");
const legacyDatasetRepo = require("./legacy-dataset-repo");
exports.legacyDatasetRepo = legacyDatasetRepo;
const resolve_1 = require("./util/resolve");
Object.defineProperty(exports, "AFFILIATION_DS_OVERRIDES", { enumerable: true, get: function () { return resolve_1.AFFILIATION_DS_OVERRIDES; } });
exports.default = torch_data_definitions_1.default;
